// src/components/User/Home/HomePage/WhatISolveSection.js
import React from "react";

const PILLARS_TOP = [
    {
        title: "Acquisition",
        description: "Improve CAC, conversion and channel economics.",
    },
    {
        title: "Engagement",
        description:
            "Understand user behaviour and build journeys that create habit and repeat usage.",
    },
    {
        title: "Retention",
        description:
            "Find where users drop, why they churn and what can move the retention curve.",
    },
];

const PILLARS_BOTTOM = [
    {
        title: "Monetization",
        description:
            "Increase AOV, LTV and revenue through offers, pricing, category expansion and lifecycle opportunities.",
    },
    {
        title: "Margin",
        description: "Improve contribution margin and customer economics while continuing to grow.",
    },
];

export default function WhatISolveSection() {
    return (
        <section
            id="what-i-solve"
            className="px-6 md:px-12 lg:px-36 py-10 md:py-12 scroll-mt-14 border-t border-[rgba(0,0,0,0.06)]"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[1000px] mx-auto">

                {/* SECTION HEADING */}
                <div className="mb-8">
                    <h2
                        className="text-3xl md:text-4xl font-extrabold tracking-tight"
                        style={{ color: "var(--text-primary)" }}
                    >
                        What I Solve
                    </h2>
                </div>

                {/* ROW 1: ACQUISITION | ENGAGEMENT | RETENTION (3 COLUMNS) */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-8">
                    {PILLARS_TOP.map((item, idx) => (
                        <div key={idx} className="flex flex-col">
                            <h3
                                className="text-xl md:text-2xl font-bold tracking-tight mb-2"
                                style={{ color: "var(--text-primary)" }}
                            >
                                {item.title}
                            </h3>
                            <p
                                className="text-base md:text-[1.05rem] leading-relaxed"
                                style={{ color: "var(--text-secondary)" }}
                            >
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* ROW 2: MONETIZATION | MARGIN (2 COLUMNS) */}
                <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-8">
                    {PILLARS_BOTTOM.map((item, idx) => (
                        <div key={idx} className="flex flex-col">
                            <h3
                                className="text-xl md:text-2xl font-bold tracking-tight mb-2"
                                style={{ color: "var(--text-primary)" }}
                            >
                                {item.title}
                            </h3>
                            <p
                                className="text-base md:text-[1.05rem] leading-relaxed"
                                style={{ color: "var(--text-secondary)" }}
                            >
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* THESIS CALLOUT */}
                <div className="mt-10 pt-6 border-t border-[rgba(0,0,0,0.08)]">
                    <blockquote
                        className="text-lg md:text-xl font-medium leading-relaxed max-w-[75ch]"
                        style={{ color: "var(--text-primary)" }}
                    >
                        “I look at the business as a whole, because growth problems rarely belong to one function.”
                    </blockquote>
                </div>

            </div>
        </section>
    );
}
